import React from 'react';
import { RecruitmentSearchRecruitment, RecruitmentState } from 'src/client/generated';
import { RecruitmentClosedLabel, WorkAddressIcon, WorkTaskIcon, WorkTimeIcon } from 'client/components/common/icons';
import { RecruitmentTag } from 'src/client/components/common/RecruitmentTag';
import { Review } from './Review';
import { NotExistReview } from './NotExistReview';
import { DeadLine } from 'client/components/recruitments/RecruitmentList/Item/DeadLine';
import { BonusLabel } from '../../BonusLabel';

type Props = {
  recruitment: RecruitmentSearchRecruitment;
};

export const RecruitmentListItem = ({ recruitment }: Props) => {
  const {
    tags,
    capacity,
    endsAt,
    facility,
    travelAllowanceLabel,
    remainingRecruitmentNumbers,
    representativeImage,
    salary,
    startsAt,
    tasks,
    title,
    state,
    review,
    deadline,
    bonus,
  } = recruitment;

  const isRecruitmentCompleted = state === RecruitmentState.Closed;

  const fetchWorkDayOfWeek = (workday: string) => {
    const DAY_OF_WEEK = ['日', '月', '火', '水', '木', '金', '土'];
    const daySlice = workday.slice(0, 10);
    const daySplit = daySlice.split('-');

    const fetchDayOfWeekNumber = new Date(
      parseInt(daySplit[0]),
      parseInt(daySplit[1]) - 1,
      parseInt(daySplit[2]),
    ).getDay();
    return DAY_OF_WEEK[fetchDayOfWeekNumber];
  };

  const workdayFormatter = (workday: string) => {
    const daySlice = workday.slice(0, 10);
    const daySplit = daySlice.split('-');
    return daySplit;
  };
  const workTimeFormatter = (workTime: string) => {
    const timeSlice = workTime.slice(11, 19);
    const timeSplit = timeSlice.split(':');
    return timeSplit;
  };

  const workTime = `${workdayFormatter(startsAt)[1]}/${workdayFormatter(startsAt)[2]}(${fetchWorkDayOfWeek(
    startsAt,
  )}) ${workTimeFormatter(startsAt)[0]}:${workTimeFormatter(startsAt)[1]} - ${workTimeFormatter(endsAt)[0]}:${
    workTimeFormatter(endsAt)[1]
  }`;

  return (
    <>
      <div className="shadow-[0px_2px_5px_rgba(0,0,0,0.2)] max-w-[335px] bg-white rounded-xl">
        {isRecruitmentCompleted && (
          <span className="absolute z-0">
            <RecruitmentClosedLabel width={75} height={75} />
          </span>
        )}
        <img
          className="w-[335px] h-[259px] object-cover bg-cover rounded-[12px_12px_0_0] card_top"
          src={representativeImage || undefined}
          alt=""
          loading="lazy"
        />

        <DeadLine deadLineDate={new Date(deadline)} isRecruitmentCompleted={isRecruitmentCompleted} />

        <div className="my-[10px] mx-3 pb-4">
          <BonusLabel className="mb-[7px]" bonus={bonus} />
          <div className="leading-[25px] tracking-[0px] text-light-black font-bold text-left">{title}</div>

          <div className="my-2">
            <div className="flex flex-wrap mt-5">
              {tags.map((o, i) => (
                <RecruitmentTag
                  name={o.name}
                  backgroundColor={o.color.background}
                  fontColor={o.color.font}
                  borderColor={o.color.border}
                  key={i}
                />
              ))}
            </div>
          </div>

          <div className="mb-6 flex flex-col gap-0.5">
            <RecruitmentItem icon={<WorkTaskIcon width={15} />} content={tasks} />
            <RecruitmentItem icon={<WorkAddressIcon width={15} />} content={facility.address} />
            <RecruitmentItem
              icon={<WorkTimeIcon width={15} />}
              content={
                <>
                  <div className="text-sm text-light-black font-bold">{workTime}</div>
                  <div className="ml-auto">
                    <span className="text-xl font-semibold text-light-black">{salary.toLocaleString()}</span>
                    <span className="text-sm">円</span>
                    <div>
                      <span className="text-xs text-light-gray3">{travelAllowanceLabel}</span>
                    </div>
                  </div>
                </>
              }
            />
          </div>

          <div className="flex items-center mb-1">{review ? <Review review={review} /> : <NotExistReview />}</div>

          <div className="flex justify-between">
            <div className="text-xs text-green flex items-center font-bold mt-1">{facility.name}</div>
            <div>
              <span className="text-xs mr-2 text-light-black font-bold">募集人数</span>
              <span className="text-xs text-red">
                残り<span className="text-base">{remainingRecruitmentNumbers}</span>/{capacity}
                <span>名</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .card_top {
          background: linear-gradient(180deg, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.400623) 100%);
        }
      `}</style>
    </>
  );
};

const RecruitmentItem = ({ icon, content }: { icon: React.ReactNode; content: React.ReactNode }) => {
  return (
    <div className="text-[13px] mt-[5px] text-black flex items-center text-left">
      <div className="text-xs mr-1 mt-px">{icon}</div>
      {content}
    </div>
  );
};
